import { styled } from '@mui/material'

import { rightColumnBoxShadow } from './utils'

export const PickerTrigger = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderColor: theme.palette.divider,
  borderLeftStyle: 'solid',
  borderLeftWidth: 1,
  boxShadow: rightColumnBoxShadow,
}))

export const PopoverContent = styled('div')<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  backgroundColor: theme.palette.background.paper,
  borderColor: theme.palette.divider,
  borderRadius: theme.spacing(3),
  borderStyle: 'solid',
  borderWidth: 1,
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateColumns: isExpanded ? '1fr 1fr' : '1fr',
  margin: theme.spacing(1),
  overflow: 'hidden',
  width: 320,
}))

export const ColumnsPanel = styled('div')<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  backgroundColor: theme.palette.background.default,
  boxSizing: 'border-box',
  maxHeight: '50vh',
  minHeight: isExpanded ? 502 : undefined,
  overflow: 'auto',
  padding: theme.spacing(2.5),
}))

export const SectionHeading = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}))

export const LoadingContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
})

export const AvailableNodeRow = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}))

export const SearchContainer = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}))

export const NodesList = styled('div')(({ theme }) => ({
  flexGrow: 1,
  paddingBottom: theme.spacing(0.75),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  paddingTop: theme.spacing(0.75),
}))

export const CategoriesRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: 502,
  width: 320,
}))

export const CategoriesContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
})

export const CategoriesHeader = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
}))

export const DynamicColumnsHeader = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1.5),
}))

export const DynamicColumnRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5),
}))

export const PaginationContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.75),
  padding: theme.spacing(1.5),
}))

export const StaticColumnRow = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(1.5),
}))
